import {
  type UseInfiniteQueryOptions,
  useInfiniteQuery,
} from '@tanstack/react-query';
import { concat } from 'lodash';
import { PaginationResponse } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetLocationTimezones = (
  filters: string[] = [],
  overrideQuerySetting?: UseInfiniteQueryOptions<PaginationResponse<string[]>>,
) => {
  return useInfiniteQuery({
    queryKey: queryKeys.getLocationTimezones.pagination(filters),
    queryFn: ({ pageParam = 1 }) =>
      fetchLocationTimezones(concat(filters, [`page=${pageParam}`])),
    staleTime: Infinity,
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = lastPage ? allPages.length : 1;
      const totalPages = lastPage ? lastPage.totalPages : 1;

      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    ...overrideQuerySetting,
  });
};

const fetchLocationTimezones = async (
  filters: string[] = [],
): Promise<PaginationResponse<string[]>> => {
  const url = `/getLocationTimezones${generateQuery([], filters)}`;
  const response = await requestCCApi({ url });

  return {
    data: response.data,
    totalPages: response.totalPages ?? 0,
    totalCount: response.totalCount ?? 0,
  } as PaginationResponse<string[]>;
};
